module.exports = __webpack_public_path__ + "static/media/template-master-products.04915b73.csv";


//////////////////
// WEBPACK FOOTER
// ./src/assets/template-master-products.csv
// module id = 1881
// module chunks = 1